import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=00b4ef72&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=00b4ef72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4ef72",
  null
  
)

export default component.exports